const base = {
  fontWeight: 400,
  lineHeight: '125%',
  size: 'sm',
  variant: 'tertiary',
  intent: 'brand',
}

const baseStyle = {
  button: {
    ...base,
    minW: 24,
  },
  ellipsis: { ...base },
  goToPage: { ...base },
  prevNext: {
    ...base,
  },
  results: {
    color: 'sandstone.30',
  },
}

const defaultProps = {}

const parts = ['container', 'button', 'ellipsis', 'goToPage', 'navigation', 'prevNext', 'results']

const variants = {}

export default {
  baseStyle,
  defaultProps,
  parts,
  variants,
}
